import { Tickets } from "@containers/HomePage/Tickets";
import { ListTicketRequest } from "@functions-types";
import { makeStyles } from "@providers/Mui";
import React from "react";

type ApprovalsCreatedByMeProps = {};

const getTicketsCreatedByMeFilter = (userId: string): ListTicketRequest => ({
  query: {
    where: [
      ["createdBy.id", "==", userId],
      ["approvalRules", "!=", null],
    ],
    orderBy: [
      ["approvalRules", "asc"],
      ["createdAt", "desc"],
    ],
  },
});

const useStyles = makeStyles((theme) => ({
  tickets: {
    maxHeight: "100%",
  },
}));

export const ApprovalsCreatedByMe: React.FC<ApprovalsCreatedByMeProps> = () => {
  const classes = useStyles();

  return (
    <Tickets
      classes={{ root: classes.tickets }}
      getFilter={getTicketsCreatedByMeFilter}
      title="Tickets created by me (that requires approvals)"
      columns={["title", "status", "severity", "category", "approvalState"]}
    />
  );
};
